import React, { ComponentType } from 'react';
import { useAiEnabled } from 'hooks/ai-firm-settings-hooks';

/**
 * Higher-Order Component that provides AI settings to class components
 *
 * @param WrappedComponent - The component to wrap with AI settings
 * @returns A new component with AI settings passed as props
 */
export const withAISettings = <P extends object>(
  WrappedComponent: ComponentType<
    P & { aiSettings?: ReturnType<typeof useAiEnabled> }
  >,
) => {
  // Return a functional component
  const WithAISettingsComponent = (props: P) => {
    // Use the hook to get AI settings
    const aiSettings = useAiEnabled();

    // Pass the AI settings as a prop to the wrapped component
    return <WrappedComponent {...props} aiSettings={aiSettings} />;
  };

  // Set display name for better debugging
  WithAISettingsComponent.displayName = `withAISettings(${
    WrappedComponent.displayName || WrappedComponent.name || 'Component'
  })`;

  return WithAISettingsComponent;
};

export default withAISettings;
